import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton } from 'shared/components';
import { IssueIcon } from 'shared/assets/icons';
import { useNoteIssueContext } from '../../contexts';
export var IssueButton = function (_a) {
    var disclosure = _a.disclosure, appointment = _a.appointment;
    var canSubmitIssue = true;
    var setActiveAppointment = useNoteIssueContext().setActiveAppointment;
    var onClick = function () {
        setActiveAppointment(appointment);
        disclosure.onOpen();
    };
    return (_jsx(IconButton, { "data-testid": "submitIssueButton", variant: "unstyled", rounded: "full", backgroundColor: "tertiary1.light", "aria-label": "Submit issue", color: "gray.500", icon: _jsx(IssueIcon, {}), disabled: !canSubmitIssue, onClick: onClick, w: 8, h: 8, minW: "auto", display: "flex", alignItems: "center", justifyContent: "center", _hover: {
            borderColor: 'tertiary1.400',
            borderWidth: '2px',
        } }));
};
